import { Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers";
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook";
import { useGetScrapeEntriesQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import { ScrapeEntryType } from "../../Types/scrapeEntryType"
import { Button } from "react-bootstrap"
import ScrapeEntry from "../../Components/ScrapeEntry/ScrapeEntryEntry/ScrapeEntryEntry"

export default function ScrapeEntriesPage() {

    const dispatch = useAppDispatch()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        limit: 10,
    })

    const {
        data,
        error,
        isLoading,
    } = useGetScrapeEntriesQuery({
        scrapeEntriesQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    })
    const scrapeEntriesList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/scrape-entries?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Scrape Entries</h1>
                        <Button 
                            variant="primary" 
                            onClick={() => dispatch(navigateTo('/add-scrape-entry'))}
                        >
                            Add New Scrape Entry
                        </Button>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        layout={{ xs: 2 }}
                        initialData={{
                            createdDateStart: activeQuery.query.createdDateStart,
                            createdDateEnd: activeQuery.query.createdDateEnd,
                            lastScrapeStart: activeQuery.query.lastScrapeStart,
                            lastScrapeEnd: activeQuery.query.lastScrapeEnd,
                            lastParseStart: activeQuery.query.lastParseStart,
                            lastParseEnd: activeQuery.query.lastParseEnd,
                            source: activeQuery.query.source,
                            type: activeQuery.query.type,
                            dataId: activeQuery.query.dataId,
                            success: activeQuery.query.success,
                            error: activeQuery.query.error,
                        }}
                        fields={[
                            {
                                fieldName: 'createdDateStart',
                                fieldLabel: 'Created Date Start',
                                fieldType: 'date',
                                placeholder: 'Created Date Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'createdDateEnd',
                                fieldLabel: 'Created Date End',
                                fieldType: 'date',
                                placeholder: 'Created Date End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'lastScrapeStart',
                                fieldLabel: 'Last Scrape Start',
                                fieldType: 'date',
                                placeholder: 'Last Scrape Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'lastScrapeEnd',
                                fieldLabel: 'Last Scrape End',
                                fieldType: 'date',
                                placeholder: 'Last Scrape End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'lastParseStart',
                                fieldLabel: 'Last Parse Start',
                                fieldType: 'date',
                                placeholder: 'Last Parse Start',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'lastParseEnd',
                                fieldLabel: 'Last Parse End',
                                fieldType: 'date',
                                placeholder: 'Last Parse End',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'source',
                                fieldLabel: 'Source',
                                fieldType: 'text',
                                placeholder: 'Source',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'type',
                                fieldLabel: 'Type',
                                fieldType: 'text',
                                placeholder: 'Type',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'dataId',
                                fieldLabel: 'Data ID',
                                fieldType: 'text',
                                placeholder: 'Data ID',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'success',
                                fieldLabel: 'Success',
                                fieldType: 'select',
                                placeholder: 'Success',
                                options: [
                                    { value: '', text: 'All' },
                                    { value: 'true', text: 'Success' },
                                    { value: 'false', text: 'Failed' }
                                ],
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'error',
                                fieldLabel: 'Has Error',
                                fieldType: 'select',
                                placeholder: 'Has Error',
                                options: [
                                    { value: '', text: 'All' },
                                    { value: 'true', text: 'Has Error' },
                                    { value: 'false', text: 'No Error' }
                                ],
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            }
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            loadPage({
                                query: values,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="scrape-entries-list-container">
                        {scrapeEntriesList && scrapeEntriesList.length > 0 ? (
                            <div>
                                {scrapeEntriesList.map((scrapeEntry: ScrapeEntryType, idx: number) => (
                                    <ScrapeEntry
                                        key={`${scrapeEntry._id}-${idx}`}
                                        scrapeEntryData={scrapeEntry}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <h5>No scrape entries found</h5>
                                <p>Try adjusting your search filters or add a new scrape entry.</p>
                            </div>
                        )}
                    </div>

                    <MongoPagination
                        data={data}
                        loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                            loadPage({
                                query: activeQuery.query,
                                limit: activeQuery.limit,
                                ...pageLoadInfo
                            })
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}